/**
 * 该文件存放账号管理相关页面路由
 */

const accountManageRoutes = [
  {
    path: '/',
    component: () => import('@/homepage'),
    children: [
      // 账户管理
      {
        path: '/capital-manage',
        name: 'CapitalManage',
        meta: {
          menuName: 'capital-manage',
        },
        component: () => import('@/pages/capitalmanage/capital-manage')
      },
      // 账号管理
      {
        path: '/admin',
        name: 'Admin',
        meta: {
          menuName: 'accout-manage'
        },
        component: () => import('@/pages/admin/admin')
      },
      // 账号注销
      {
        path: '/account-cancellation',
        name: 'AccountCancellation',
        meta: {
          menuName: 'accout-manage'
        },
        component: () => import('@/pages/account-cancellation')
      },
    ]
  }
];

export default accountManageRoutes;
